import { render } from "./PedidosMenu.vue?vue&type=template&id=f598bf18"
import script from "./PedidosMenu.vue?vue&type=script&lang=js"
export * from "./PedidosMenu.vue?vue&type=script&lang=js"

import "./PedidosMenu.vue?vue&type=style&index=0&id=f598bf18&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__